module.exports = __webpack_public_path__ + "static/media/colorcon_portfolio_2x.48c3b418.jpeg";